// extracted by css-extract-rspack-plugin
export default {"CouldNotFindFallbackErrorContainer":"CouldNotFindFallbackError-module__CouldNotFindFallbackErrorContainer__fOygj"};